import { useState } from "react";
import { motion } from "framer-motion";
import { Minus, Plus, Store } from "lucide-react";

const fmt = (n) => `$${n.toFixed(2)}`;

export const SplitBillDemo = () => {
  const [total, setTotal] = useState(84);
  const [people, setPeople] = useState(3);
  const per = total / people;

  return (
    <div
      data-testid="split-bill-demo"
      className="rounded-lg border border-border bg-card p-6 sm:p-8"
    >
      <div className="flex items-center justify-between">
        <span className="eyebrow text-muted-foreground">Direct Split · Live Demo</span>
        <span className="font-mono-ui text-xs text-muted-foreground">no P2P</span>
      </div>

      <div className="mt-6 space-y-5">
        <div>
          <div className="flex items-center justify-between text-sm">
            <label className="text-muted-foreground">Bill total</label>
            <span className="font-mono-ui font-medium text-foreground">{fmt(total)}</span>
          </div>
          <input
            type="range"
            min="10"
            max="400"
            step="1"
            value={total}
            data-testid="split-bill-total-slider"
            onChange={(e) => setTotal(Number(e.target.value))}
            className="mt-2 w-full accent-foreground"
          />
        </div>

        <div className="flex items-center justify-between">
          <label className="text-sm text-muted-foreground">Guests</label>
          <div className="flex items-center gap-3">
            <button
              type="button"
              data-testid="split-bill-people-minus"
              onClick={() => setPeople((p) => Math.max(1, p - 1))}
              className="grid h-8 w-8 place-items-center rounded-md border border-border transition-colors hover:bg-accent"
            >
              <Minus className="h-3.5 w-3.5" />
            </button>
            <span className="w-6 text-center font-mono-ui font-medium">{people}</span>
            <button
              type="button"
              data-testid="split-bill-people-plus"
              onClick={() => setPeople((p) => Math.min(12, p + 1))}
              className="grid h-8 w-8 place-items-center rounded-md border border-border transition-colors hover:bg-accent"
            >
              <Plus className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-3">
        {Array.from({ length: people }).map((_, i) => (
          <motion.div
            key={`guest-${i}`}
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, delay: i * 0.03 }}
            className="flex items-center justify-between rounded-md border border-border bg-secondary px-3 py-2"
          >
            <span className="text-xs text-muted-foreground">Guest {i + 1}</span>
            <span className="font-mono-ui text-sm font-medium">{fmt(per)}</span>
          </motion.div>
        ))}
      </div>

      <div className="mt-5 flex items-center gap-2 rounded-md bg-foreground px-4 py-3 text-background">
        <Store className="h-4 w-4" />
        <p className="text-xs">
          Each guest pays <span className="font-semibold">{fmt(per)}</span> directly to the merchant.
        </p>
      </div>
    </div>
  );
};
